import { computed, DestroyRef, Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { isPlatformServer } from '@angular/common';

import { ListSearchKeywordsResponse } from '@proto/store/api/store/search';
import { BaseViewModel } from '../../base-view-model';
import { SearchRepositoryService } from '@service/search-repository.service';
import { MetaData } from '@helper/meta-data';
import { RoutePaths } from '@helper/route-paths';

import { isEqual } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class EmptySearchModel extends BaseViewModel<ListSearchKeywordsResponse> {
  readonly maxKeyword = 10;
  readonly desktopHotKeywords = computed(() => this.apiResult().hotKeywords.slice(0, this.maxKeyword), {
    equal: (a, b) => isEqual(a, b),
  });
  readonly previousKeyword = signal('');

  constructor(
    private lativRepository: SearchRepositoryService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    super(ListSearchKeywordsResponse.fromPartial({}));
  }

  listSearchKeywords(ref: DestroyRef): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.lativRepository
      .listSearchKeywords()
      .pipe(takeUntilDestroyed(ref))
      .subscribe({
        next: data => this.setApiResult(data),
        error: err => this.setApiError(err),
      });
  }

  override getMetaByUrl(segments: string[]): MetaData | undefined {
    if (segments[0] !== RoutePaths.SEARCH) {
      this.previousKeyword.set('');
    }
    return undefined;
  }
}
